export const currentLocale = function () {
    return document.documentElement.lang;
};
